export default {
    contentOnly: {
        navPos: false,
        toolbar: false,
        toolbarPos: "bottom",
        footer: false,
    },
    register: {
        navPos: false,
        toolbar: false,
        toolbarPos: "bottom",
        footer: "below",
    },
    navLeft: {
        navPos: "left",
        toolbar: "bottom",
        boxed: false,
        roundedCorners: false,
        footer: "below",
    },
    navRight: {
        navPos: "right",
        toolbar: "bottom",
        boxed: false,
        roundedCorners: false,
        footer: "below",
    },
    navTop: {
        navPos: "top",
        toolbar: "bottom",
        boxed: false,
        roundedCorners: false,
        footer: "below",
    },
    navBottom: {
        navPos: "bottom",
        toolbar: "bottom",
        boxed: false,
        roundedCorners: false,
        footer: "below",
    },
};
